module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0003.1f54fb7a.jpg";